<script>
import form from './form'

export default {
  extends: form,

  methods: {
    onSubmit() {
      return this.$apiMethods.stores.create({ ...this.form, ...this.getCoords, is_external: false })
        .then(() => {
          this.successSubmit({ message: 'Склад успешно создан', routeName: 'rcc-stores' })
        })
        .finally(() => { this.afterSubmit() })
    }
  }
}
</script>